module.exports = __webpack_public_path__ + "media/packs/compcalc/components/icons/support-9ec0070ff84d2c95f7dd9bf931b3d264.png";